export enum ViewMode {
  rows = 'rows',
  cards = 'cards',
}

export interface BEConfig {
  TSEVO_DISABLED: boolean;
  ECHECK_EARLY_DEPOSIT_AMOUNT: number;
  blockedCashPlayStates: BlockState[] | null;
  daysToCancelApprovedRequests: number | null;
  depositFee: number | null;
  withdrawalFee: number | null;
}

export interface BlockState {
  abbr: string;
  state: string;
}

export interface IPageModel {
  pageIndex: number;
  pageSize: number;
}

export interface IColumnModel {
  showCustomPopover?: any;
  id: string;
  title: string;
  class?: string;
  align?: alignPositions;
  srcImg?: string;
  type: any;
  mapping: any;
  tooltip: any;
  sort?: any;
  customElement?: any;
  customMobileTitle?: any;
  highlight?: any;
  link?: any;
  customMobileType?: any;
  customPopover?: any;
  tournament?: any;
  referenceID?: any;
  eventSchedule?: any;
  passUuid?: any;
  playButtonText?: any;
  playButtonIsBasic?: boolean;
  actionsToShow?: any;
}

export interface IElementModel {
  data: any;
  cellName: string;
}

export interface ITableConfig {
  fixedLayout?: boolean;
  headersTooltip?: Record<string, string>;
  pagination?: {
    showPagination?: boolean;
    paginationTotal?: number | null;
    pageSize?: number | null;
    indexQueryParam: string;
    sizeQueryParam: string;
    paginationSizeOptions: number[];
  };
  tableName: string;
  highlightedRow?: string;
  emptyState?: {
    title?: string;
    src?: string;
    loggedInMessage?: string;
    loggedOutMessage?: string;
    buttonText?: string;
  };
}

export enum columnTypes {
  'IMG' = 'image',
  'EVENT' = 'event',
  'DATE' = 'date',
  'CURRENCY' = 'currency',
  'RANGE' = 'range',
  'AVATAR' = 'avatar',
  'LINK' = 'link',
  'ACTIONS' = 'actions',
  'DEFAULT' = 'default',
  'DETAILS' = 'details',
  'CUSTOM' = 'custom',
  'CHIP' = 'chip',
  'TRANSACTION_TYPE' = 'transactionTypeAlias',
}

export enum actionTypes {
  'PLAY' = 'playButton',
  'DETAILS' = 'details',
  'REFERRALS' = 'referrals',
  'SHARE' = 'share',
  'CANCEL' = 'cancel',
  'COMPLETE' = 'complete',
  'RETRY' = 'retry',
  'CUSTOM' = 'custom',
  'HTML' = 'html',
}
export enum alignPositions {
  'RIGHT' = 'right',
  'CENTER' = 'center',
  'LEFT' = 'left',
}
